import { useContext } from 'react';

import { QuestionCreationTaskDetailsContext } from './question-creation-task-details-provider';

function useQuestionCreationTaskDetails() {
  const context = useContext(QuestionCreationTaskDetailsContext);

  if (!context) {
    throw new Error(
      'useQuestionCreationTaskDetails must be used within a QuestionCreationTaskDetailsProvider',
    );
  }

  return context;
}

export { useQuestionCreationTaskDetails };
